import { MinusIcon, PlusIcon } from '@heroicons/react/solid';
import { Collapse } from 'antd';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import type React from 'react';

import { IFaq } from '@/pages/books/shop/[category]';

const { Panel } = Collapse;
interface Props {
  faqData: IFaq[];
  parentClassName?: string;
}

const CategoryFaqSection: React.FC<Props> = ({ faqData, parentClassName }) => {
  return (
    <div
      className={
        parentClassName ? ' text-white w-full flex ' : ' text-white  m-auto'
      }
    >
      <div className={parentClassName ?? 'px-4 md:px-6 lg:px-12 xl:px-[220px]'}>
        <h2 className='text-lg xxxs:text-xl sm:text-2xl md:text-[32px] font-semibold mb-8 '>
          Frequently Asked Questions
        </h2>
        <div className='border border-t-grayZl-850 border-transparent '>
          <Collapse
            accordion
            defaultActiveKey={['1']}
            ghost
            expandIconPosition='right'
            style={{ borderRadius: 0 }}
            expandIcon={({ isActive }) => (
              <AnimatePresence mode='wait' initial={false}>
                <motion.div
                  key={isActive ? 'minus' : 'plus'}
                  initial={{ rotate: 90, opacity: 0 }}
                  animate={{ rotate: 0, opacity: 1 }}
                  exit={{ rotate: -90, opacity: 0 }}
                  transition={{ duration: 0.15 }}
                >
                  {isActive ? (
                    <MinusIcon className='text-white w-4 h-4' />
                  ) : (
                    <PlusIcon className='text-white w-4 h-4' />
                  )}
                </motion.div>
              </AnimatePresence>
            )}
            className='customCollapseCategories rounded-none '
          >
            {faqData.map((item, index) => (
              <Panel
                header={
                  <span
                    className={clsx(
                      'text-white text-sm md:text-base rounded-none sm:text-md font-semibold',
                    )}
                  >
                    {item.question}
                  </span>
                }
                key={`${item.question}-${index}`}
              >
                <span className='text-xs md:text-sm font-light text-grayZl-500'>
                  {item.answer}
                </span>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default CategoryFaqSection;
